module.exports = __webpack_public_path__ + "static/media/Priyanka_Bed_Lebenslauf.f07e70fe.pdf";